import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  permission: null,
  loading: true
}

const permissionSlice = createSlice({
  name: 'permission',
  initialState,
  reducers: {
    setPermission: (state, action) => {
      state.permission = action.payload
    },
    setPermissionLoading: (state, action) => {
      state.loading = action.payload
    }
  }
})

export const {setPermission, setPermissionLoading} = permissionSlice.actions

export const selectPermission = (state) => state.permission?.permission ?? null
export const selectPermissionLoading = (state) => state.permission?.loading ?? true

export default permissionSlice.reducer
